<template>
	<div class="row">
		<div class="col-6 device-condition">
			{{ input.name }}
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-icon color="default" v-on="on"> mdi-information-variant </v-icon>
				</template>
				<span v-html="input.help_text"></span>
			</v-tooltip>
		</div>
		<div class="col-6" v-if="input.type === 'boolean'">
			<v-radio-group v-model="selected" @change="update" row :error-messages="infoMessages">
				<v-radio
					v-for="(choice, index) in input.choices"
					:key="index"
					:label="choice.label"
					:value="choice.value"
					:ripple="false"
					:disabled="disabled"
					:name="slugify(input.name)"
				/>
			</v-radio-group>
		</div>
		<div class="col-6" v-if="input.type === 'list'">
			<v-autocomplete
				v-model="selected"
				item-text="label"
				item-value="value"
				:items="input.choices"
				:disabled="disabled"
				:menu-props="{ closeOnClick: true, offsetY: true }"
				attach
				@change="update"
				:name="slugify(input.name)"
				outlined
				:error-messages="infoMessages"
			/>
		</div>
	</div>
</template>

<script>
import { slugify } from '../../../../js/buyout';
import {VUEX_BUYOUT} from '../../../../vue/store/buyout/index';
import {mapState} from 'vuex';
import {EventBus} from "../../../event_bus";

export default {
	name: 'DynamicFormInput',
	props: {
		input: {
			type: Object,
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		index: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			selected: null
		}
	},
	created() {
		this.updateDefaultConditions();
		EventBus.$on('updateAppraisalConditions', () => {
			this.updateDefaultConditions();
		});
	},
	computed: {
		...mapState(VUEX_BUYOUT.NAMESPACE,[
			'defaultQualityConditions'
		]),
		selectedChoice() {
      return this.input.choices.find(choice => choice.value === this.selected);
    },
		priceCorrection() {
			if (!this.selectedChoice.price_correction || this.selectedChoice.price_correction === 0) return [];
			return [this.$n(this.selectedChoice.price_correction, "currency")];
		},
		infoMessages() {
      if (this.priceCorrection.length) {
        return this.priceCorrection + '*';
      }

      return null;
    },
	},
	methods: {
		slugify: string => slugify(string),
		update() {
      if (!this.selectedChoice) return;
      this.$emit('input', {
        id: this.input.id,
        value: this.selectedChoice.value,
        appraisal_result: this.selectedChoice.appraisal_result,
				price_correction: this.selectedChoice.price_correction,
      });
    },
		updateDefaultConditions() {
			this.input.choices.forEach(choice => {
				if (this.defaultQualityConditions.includes(choice.value))
					this.selected = choice.value;
			});
			if (!this.selected) this.selected = this.input.choices[0].value;

			this.update();
		}
	},
	watch: {
		defaultQualityConditions() {
			this.updateDefaultConditions();
		}
	}
}
</script>
